import { render, staticRenderFns } from "./BusinessHours.vue?vue&type=template&id=27264069&"
import script from "./BusinessHours.vue?vue&type=script&lang=js&"
export * from "./BusinessHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports